
// 该插件需要中国地图数据json，还有引入echarts.js
// __PUBLIC__/static/libs/china.json

class EchartsChina {
    constructor(options) {
        this.myChart = null;
        this.defaultOptions = {
            canvas: null,
            chinaJsonUrl: '',//中国地图数据json格式
            extraCssText: 'white-space: normal;box-shadow: 0px 3px 16px 0px rgb(2 20 40 / 18%);overflow: hidden;border-radius:6px;padding: 30px 25px;background-color: #fff;color: #666666;transform: translate(-100%, -50%);width: 243.6px;',
            geoData: [],//地图
            mapData: [],//渲染在地图上的数据
            mapContainer:  '.china-map', //echarts的container
            mapBgColor: '#a6a6a6', //地图背景
            mapBgEmphasis: '#F60515', //地图背景高亮
            symbol: 'circle', //标记的图形，'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
            symbolSize: 5,
            symbolBgColor: '#ffffff', //标记的背景颜色
            symbolBgEmphasis: '#f7e496',//标记的背景高亮
            customHtml: function () {},//弹窗的自定义html
            tooltipPosition: ['100%','50%'], //弹窗的位置
            openFn: function(){},
            closeFn: function(){},
            geoZoom: 1,
            geoClient: false,
            borderWidth: 3,
            series: [],
            tooltip_enterable: false,
            map_name: 'china',
            initRegisterMap: true,
            series_ouput_data: null,
        };
        this.options = Object.assign(this.defaultOptions, options);
        this.init();
    }
    setOption() {
        let that = this;
        let option = {
            tooltip: {
                trigger: 'item', // 图形触发
                // alwaysShowContent: true, // 是否永远显示提示框内容
                position: this.options.tooltipPosition, // 浮层的位置
                triggerOn: 'none', // 浮层的触发条件
                enterable: this.options.tooltip_enterable,
                // 额外附加到浮层的 css 样式
                extraCssText: that.options.extraCssText,
                formatter: function (params) {  //提示框浮层内容格式器
                    return that.options.customHtml(params);
                }
            },
            geo: {
                map: this.options.map_name,
                show: true,
                roam: false, //拖动和缩放
                zoom: this.options.geoZoom,
                silent: this.options.geoClient, //不响应触发的鼠标事件
                label: {
                    normal: {
                        show: false
                    },
                    emphasis: {
                        show: false,
                    }
                },
                ...(this.options.map_name == 'china' ? {regions: this.getCityList(this.options.mapData),
                    itemStyle: {
                        areaColor: this.options.mapBgColor,
                        borderColor: '#fff',//线
                        shadowColor: 'none',//外发光
                        shadowBlur: 20,
                        borderWidth: this.options.borderWidth,
                    },
                    emphasis: {
                        itemStyle: {
                            areaColor: this.options.mapBgEmphasis,//悬浮区背景
                        }
                        
                    }} : {})
            },
            series: [
                {
                    type: 'map',
                    map: 'china',
                    geoIndex: 0,
                    aspectScale: 0.75, //长宽比
                    showLegendSymbol: false, // 存在legend时显示
                    label: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: false,
                            textStyle: {
                                color: '#fff'
                            }
                        }
                    },
                    roam: true,
                    animation: false,
                    data: this.options.mapData
                },
                ...(this.options.series.length > 0 ? this.getSeries() : [
                    {
                        type: 'effectScatter',
                        coordinateSystem: 'geo',
                        symbol: this.options.symbol,
                        symbolSize: this.options.symbolSize,
                        label: {
                            normal: {
                                show: false,
                                textStyle: {
                                    color: '#fff',
                                    fontSize: 9,
                                },
                                formatter(value) {
                                    return value.data.value[2]
                                }
                            }
                        },
                        itemStyle: {
                            color: this.options.symbolBgColor, 
                        },
                        emphasis: {
                            itemStyle: {
                                color: this.options.symbolBgEmphasis
                            }
                        },
                        data: this.convertData(this.options.mapData),
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke',
                            scale: 5.8,
                        },
                        hoverAnimation: true,
                        zlevel: 1
                    },
                    {
                        symbolSize: this.options.symbolSize,
                        itemStyle: {
                            normal: {
                                color: '#fff'
                            }
                        },
                        name: 'light',
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: this.convertData(this.options.mapData),
    
                    },
                ])
            ]
        };
        this.myChart.setOption(option);
    }
    getSeries() {
        this.options.series && this.options.series.forEach((item) => {
            item['data'] = this.convertData(this.options.mapData)
        });
        return this.options.series;
    }
    getCityList(data) {
        let selectedCityList = [];
        data.forEach(item => {
            selectedCityList.push({name: item.name,selected: true});
        })
        return selectedCityList;
    }
    convertData(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
            var geoCoord = this.options.geoData[data[i].name];
            if (geoCoord) {
                res.push({
                    name: data[i].name,
                    value: this.options.series_ouput_data !== null ? geoCoord.concat(data[i].value, this.options.series_ouput_data) : geoCoord.concat(data[i].value)
                });
            }
        }
        return res;
    }
    initEcharts() {
        this.myChart = echarts.init(document.querySelector(this.options.mapContainer), null, this.options.canvas ? {
            width: this.options.canvas.width,
            height: this.options.canvas.height,
        }: {});
    }
    getChinaJson(cb) {
        if(this.options.chinaJsonUrl) {
            $.getJSON(this.options.chinaJsonUrl, function (mapData) {
                console.log("获取到的地图数据！！", mapData);
                if(cb && typeof cb === 'function') {
                    cb(mapData)
                }
            })
        }else{
            throw '缺少中国json数据地址';
        }
    }
    changeData(data) {
        this.options.mapData = data;
        this.setOption();
    }
    init() {
        this.initEcharts();
        this.options.initRegisterMap && this.myChart.showLoading();
        this.options.initRegisterMap && this.getChinaJson((data) => {
            echarts.registerMap('china', data);
            this.myChart.hideLoading();
            this.setOption();
        });
        if (this.options.openFn) {
            this.options.openFn(this.myChart);
        }
        if (this.options.closeFn) {
            this.options.closeFn(this.myChart);
        }
        // return this.myChart;
    }
    dispatchAction(option) {
        this.myChart.dispatchAction(option);
    }
    changeProvince(props) {
        const {map_name, url, geo_data, map_data} = props;
        this.options.map_name = map_name;
        this.options.chinaJsonUrl = url;
        this.options.geoData = geo_data;
        this.options.mapData = map_data;
        const maps = echarts.getMap(map_name);
        if (maps) {
            this.setOption();
        } else {
            this.myChart.showLoading();
            this.getChinaJson((data) => {
                echarts.registerMap(map_name, data);
                this.myChart.hideLoading();
                this.setOption();
            });
        }
    }
}

window.EchartsChina = EchartsChina;

